import React from 'react';
import {Alert} from '@mui/material';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import {StyleSx, Sx} from 'app/types/common';
import {Main} from 'app/components/entities/cloud';
import {packSx} from 'app/util/packSx/packSx';

const rootSx: StyleSx = {
  fontSize: 14,
};

interface Props extends Sx {
  state: Main.CodeStatus | 'disabled' | 'checking';
}

export function ValidationMessage({sx, state}: Props) {
  const sxProp = packSx(rootSx, sx);

  if (state === 'ok') {
    return (
      <Alert sx={sxProp} severity="success">
        Pairing code is valid.
      </Alert>
    );
  }

  if (state === 'invalid-code') {
    return (
      <Alert sx={sxProp} severity="error">
        Invalid pairing code.
      </Alert>
    );
  }

  if (state === 'no-seats' || state === 'no-seats-expandable') {
    return (
      <Alert sx={sxProp} severity="warning">
        No available seat in team.
      </Alert>
    );
  }

  if (state === 'checking') {
    return (
      <Alert sx={sxProp} icon={<AutorenewIcon fontSize="inherit" />} severity="info">
        Checking pairing code
      </Alert>
    );
  }

  return (
    <Alert sx={sxProp} severity="info">
      Enter pairing code
    </Alert>
  );
}
